import { SyntheticEvent, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import { CARD_ITEMS } from "components/TableDetails/DeviceDetails/types";
import EditSection from "components/TableDetails/EditSection";
import TableContext from "context/table/tableContext";
import { ENDPOINTS, useApi } from "shared";

import { DetailsData } from "../../../types";

const Description = () => {
    const { detailsData } = useContext(TableContext);

    const { imei, description }: DetailsData = detailsData;

    const { t } = useTranslation();
    const { updateData, handleResponse } = useApi();

    const [isLoading, setIsLoading] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [value, setValue] = useState("");

    useEffect(() => {
        setIsEditable(false);
        setValue(description ?? "");
    }, [imei, description]);

    const edit = () => setIsEditable(true);

    const cancel = () => {
        setIsEditable(false);
        setValue(description ?? "");
    };

    const handleChange = (e: { target: { value: string } }) =>
        setValue(e.target.value);

    const update = async (e: SyntheticEvent) => {
        e.preventDefault();

        try {
            setIsLoading(true);

            const response = await updateData(ENDPOINTS.Devices, imei, {
                description: value
            });

            setIsEditable(false);
            handleResponse(response);
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    const renderEditComponent = () => {
        if (isEditable) {
            return (
                <InputField
                    autoFocus
                    size={INPUT_FIELD_SIZES.Tiny}
                    value={value}
                    onChange={handleChange}
                    readOnly={isLoading}
                />
            );
        }

        return value || "-";
    };

    return (
        <EditSection
            sectionName={t(`Table##${CARD_ITEMS.Description}`)}
            update={update}
            isLoading={isLoading}
            isEditable={isEditable}
            edit={edit}
            cancel={cancel}
            value={value}
            copiedValue={value}
        >
            {renderEditComponent()}
        </EditSection>
    );
};

export default Description;
